function floor(value: number, digits: number): number {
  const x = Math.pow(10, digits);
  return Math.floor(value * x) / x;
}

export function floorStr(value: string, digits: number): string {
  return floor(+value, digits).toString();
}
